/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiRequestTicketStatusSearch } from '../../models/api-request-ticket-status-search';
import { ApiResponsePageTicketStatus } from '../../models/api-response-page-ticket-status';

export interface SearchStatus$Params {
      body: ApiRequestTicketStatusSearch
}

export function searchStatus(http: HttpClient, rootUrl: string, params: SearchStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageTicketStatus>> {
  const rb = new RequestBuilder(rootUrl, searchStatus.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePageTicketStatus>;
    })
  );
}

searchStatus.PATH = '/v1/api/ui/status-ticket/search';
